module.exports = __FOREMAN_VENDOR__ACE_BUILDS_SRC_NOCONFLICT_EXT_LANGUAGE_TOOLS__;